import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import _ from 'lodash';
import { Project, ProjectMeta } from '../../project.model';
import { VersionControlService } from '../../../version-control/version-control.service';
import { AppState } from '../../../model/reducer';
import { allProjectsView, projectMetaView, selectedProjectView, selectedTenantKeyView, shouldDisplayTenantsView } from '../../../model/views';

@Injectable()
export class BranchProjectContext {
  private versionControlService = inject(VersionControlService);
  private store$ = inject<Store<AppState>>(Store);

  projects$: Observable<Project[]>;
  selectedTenantKey$: Observable<string>;
  displayTenant$: Observable<boolean>;
  selectedProject$: Observable<Project | null>;
  projectMeta$: Observable<ProjectMeta | null>;

  constructor() {
    this.projects$ = this.store$.pipe(select(allProjectsView), map(_.values));
    this.selectedTenantKey$ = this.store$.pipe(select(selectedTenantKeyView)) as Observable<string>;
    this.displayTenant$ = this.store$.pipe(select(shouldDisplayTenantsView));
    this.selectedProject$ = this.store$.pipe(select(selectedProjectView), map((project: Project | undefined) => project || null));
    this.projectMeta$ = this.store$.pipe(select(projectMetaView));
  }
}
